import { Component, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'menu-icon',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
})
export class MenuIconComponent {
  @Input() public isExpanded = false;
  @Input() public size: 'small' | 'medium' | 'large' = 'medium';

  @HostBinding('class') public get class() {
    return `fr-animatedIcon fr-animatedIcon--${this.size}`;
  }
}
